import { CommonModule } from '@angular/common';
import { Component, OnInit, forwardRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NavController, NavParams, ModalController, IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { SafeHtmlPipe } from 'src/app/pipes/safe-html/safe-html';
import { GrupoProvider } from 'src/app/services/grupo/grupo';


@Component({
  selector: 'app-grupo-pauta',
  templateUrl: './grupo-pauta.page.html',
  styleUrls: ['./grupo-pauta.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SafeHtmlPipe,
    TranslateModule,
  ],
})
export class GrupoPautaPage implements OnInit {
  pauta = '';
  idReuniao: any;
  fontSize = 16;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public grupoProvider: GrupoProvider
  ) {
    this.idReuniao = this.navParams.get('idReuniao');
    this.pauta = this.navParams.get('pauta');
  }

  ngOnInit() {}

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  zoom(action: string) {
    this.fontSize += action === 'in' ? 2 : action === 'out' ? -2 : 0;
    this.updateFontSize(action);
  }

  updateFontSize(action: string) {
    const element = document.getElementById('trix');

    if (element) {
      const brTag = element.getElementsByTagName('br');
      const pTag = element.getElementsByTagName('p');

      if (brTag.length > 0 && pTag.length <= 0) {
        element.style.fontSize = `${this.fontSize}px`;
      } else {
        const zoomFactor = action === 'in' ? 1.2 : action === 'out' ? 0.8 : 1.0;
        const textNodes = this.getTextNodes(element);
        
        textNodes.forEach((node: any) => {
          let currentFontSize = this.fontSize;
          const newFontSize = currentFontSize * zoomFactor;
          this.setStyleAttribute(node.parentElement, { 'font-size': `${newFontSize}px` });
        });
      }
    }
  }

  getTextNodes(node: HTMLElement): Node[] {
    const textNodes = [];
    const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null);
    let n: Node | null;
    while ((n = walker.nextNode())) {
      textNodes.push(n);
    }
    return textNodes;
  }

  setStyleAttribute(element: HTMLElement, attrs: { [key: string]: string }): void {
    if (attrs !== undefined) {
      Object.keys(attrs).forEach((key: string) => {
        element.style.setProperty(key, attrs[key]);
      });
    }
  }

  download() {
    this.grupoProvider.downloadPauta(this.idReuniao).subscribe((data) => {
      window.open('https://portal.sistemaprover.com.br/frontend/grupo-externo?r=' + data, '_system');
    });
  }
}
